import { render, staticRenderFns } from "./CommissionRank.vue?vue&type=template&id=f4023ce2&scoped=true&"
import script from "./CommissionRank.vue?vue&type=script&lang=js&"
export * from "./CommissionRank.vue?vue&type=script&lang=js&"
import style0 from "./CommissionRank.vue?vue&type=style&index=0&id=f4023ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4023ce2",
  null
  
)

export default component.exports